import { Component } from './component';

export type TabProps = string | { label: string; id: string };

export interface TabsProps {
  tabs: TabProps[];
  multirows?: boolean;
  tabsPerRow?: number;
  selected?: string;
  onTabSelect?: (id: string, index: number) => void;
}

export class Tabs extends Component {
  public el: HTMLDivElement;
  public body: HTMLDivElement;

  constructor(props: TabsProps) {
    super();
    this.el = document.createElement('div');
    this.el.classList.add('tabs');

    const tabsPerRow = props.multirows
      ? props.tabsPerRow || 6
      : props.tabs.length;

    const numOfBars = Math.ceil(props.tabs.length / tabsPerRow);

    for (let i = 0; i < numOfBars; i++) {
      const menu = document.createElement('menu');
      menu.role = 'tablist';

      if (props.multirows) {
        menu.classList.add('multirows');
      }

      for (
        let j = i * tabsPerRow;
        j < Math.min((i + 1) * tabsPerRow, props.tabs.length);
        j++
      ) {
        const tab = props.tabs[j];
        const li = document.createElement('li');
        li.role = 'tab';

        const a = document.createElement('a');
        a.href = 'javascript:void(0);';

        if (typeof tab === 'string') {
          a.innerText = tab;

          if (tab === props.selected) {
            li.setAttribute('aria-selected', 'true');
          }
        } else {
          a.innerText = tab.label;
          if (tab.id === props.selected) {
            li.setAttribute('aria-selected', 'true');
          }
        }

        li.appendChild(a);

        li.addEventListener('click', () => {
          const allTabs = this.el.querySelectorAll('li');
          for (const t of allTabs) {
            t.removeAttribute('aria-selected');
          }
          li.setAttribute('aria-selected', 'true');

          if (props.onTabSelect) {
            props.onTabSelect(typeof tab === 'string' ? tab : tab.id, j);
          }
        });

        menu.appendChild(li);
      }

      this.el.appendChild(menu);
    }

    this.body = document.createElement('div');
    this.body.classList.add('window');
    this.body.role = 'tabpanel';
    this.el.appendChild(this.body);
  }
}
